import { getReferralPaymentHistories } from "@endpoints/stripe.service";
import { ChevronDown, ListFilter, LogOut, SearchIcon } from "lucide-react";
import { useEffect, useState } from "react";
import dayjs from "@lib/dayjs";
import LoaderPaymentReceived from "../components/LoaderPaymentReceived";

const PaymentReceived = () => {
  const [searchText, setSearchText] = useState<string | undefined>();
  const [paymentHistories, setPaymentHistories] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  async function fetchPaymentReceived() {
    try {
      setIsLoading(true);
      const response = await getReferralPaymentHistories({ searchText });
      if (response?.success) {
        setPaymentHistories(response?.data?.paymentHistories);
      }
    } catch (error) {
      console.error("Error fetching payment received", error);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    fetchPaymentReceived();
  }, []);

  return (
    <div className="flex flex-col min-h-0">
      {/* Search container */}
      <div className="flex items-center mt-6 bg-[#F1F5F9] p-1 rounded-md justify-between">
        <div className="flex items-center gap-3 w-[60%]">
          <div className="bg-white rounded-md px-3 border flex items-center h-8 flex-1">
            <input
              className="text-xs font-medium flex-1 outline-none h-full"
              placeholder="Search reference"
            />
            <SearchIcon className="w-4 h-4" color="gray" />
          </div>
          <div className="bg-white rounded-md px-3 border flex items-center h-8 gap-14">
            <span className="font-medium text-xs text-[#4D4D4D]">
              Date Filter
            </span>
            <ListFilter className="w-4 h-4" color="gray" />
          </div>
          <div className="bg-white rounded-md px-3 border flex items-center h-8 gap-10">
            <span className="font-medium text-xs text-[#4D4D4D]">Type</span>
            <ChevronDown className="w-4 h-4" color="gray" />
          </div>
        </div>
        <button className="flex items-center bg-[#6F6F6F] font-medium text-xs text-white rounded-md px-5 py-2 gap-2">
          <LogOut className="w-4 h-4" />
          Export
        </button>
      </div>
      {/* List container */}
      <div className="flex flex-col mt-14 px-2 min-h-0">
        {/* Header */}
        <div className="grid grid-cols-[1fr_2fr_1fr_1fr_1fr] border-b pb-2 px-2">
          <span className="font-semibold text-xs text-light-black">
            Reference No.
          </span>
          <span className="font-semibold text-xs text-light-black">
            Payment from
          </span>
          <span className="font-semibold text-xs text-light-black">Status</span>
          <span className="font-semibold text-xs text-light-black">Amount</span>
          <span className="font-semibold text-xs text-light-black">Date</span>
        </div>
        <div className="flex flex-col overflow-y-scroll min-h-0 no-scrollbar">
          {isLoading ? (
            <LoaderPaymentReceived />
          ) : paymentHistories?.length ? (
            paymentHistories?.map((paymentHistory) => {
              return (
                <div
                  key={paymentHistory?._id}
                  className="grid grid-cols-[1fr_2fr_1fr_1fr_1fr] px-2 py-4 border-b"
                >
                  <span className="text-xs text-primary">
                    {paymentHistory?.refNo}
                  </span>
                  <span className="text-xs text-primary">
                    {paymentHistory?.paymentFrom?.companyName}
                  </span>
                  <span className="text-xs text-[#B3261E]">Paid</span>
                  <span className="text-xs text-primary">
                    £ {paymentHistory?.totalAmount}
                  </span>
                  <span className="text-xs text-primary">
                    {dayjs(paymentHistory?.updatedAt).format(
                      "DD MM YYYY, hh:mm a"
                    )}
                  </span>
                </div>
              );
            })
          ) : (
            <div className="flex flex-col justify-center items-center h-96 font-medium text-sm">
              You haven't received any payments yet.
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentReceived;
